import { StyleSheet } from 'react-native';

import {
  neutralDark,
  neutralLight,
  peacock,
  warrior,
  white,
} from '../../../constants/color';

const styles: any = StyleSheet.create({
  homeDeliverCard: {
    width: '100%',
    flexDirection: 'column',
    alignContent: 'stretch',
    backgroundColor: white,
    paddingBottom: 10,
  },
  addressSection: {
    maxWidth: '100%',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: neutralLight,
    borderRadius: 3,
  },
  recipientTitleField: {
    marginLeft: 10,
    marginTop: 10,
  },
  recipientTitleText: {
    fontSize: 12,
    color: neutralDark,
  },
  recipientAndPhoneSection: {
    flexDirection: 'row',
    alignContent: 'center',
    marginRight: 10,
    marginLeft: 10,
    marginTop: 2,
  },
  recipientField: {
    maxWidth: '56%',
  },
  recipientText: {
    fontSize: 15,
    fontWeight: 'bold',
    color: warrior,
  },
  phoneField: {
    maxWidth: '44%',
    marginLeft: 5,
  },
  phoneText: {
    fontSize: 15,
    color: warrior,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  addressTitleField: {
    marginLeft: 10,
    marginTop: 10,
  },
  addressTitleText: {
    fontSize: 13,
    lineHeight: 16,
    color: neutralDark,
  },
  addressDetailFiled: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 2,
  },
  addressDetailText: {
    fontSize: 15,
    lineHeight: 18,
    color: warrior,
  },
  fontWeightBold: {
    fontWeight: 'bold',
  },
  mailPatternField: {
    flex: 1,
    width: '100%',
    marginTop: 10,
    height: 4,
  },
  cvsPickUpGoodsHintField: {
    marginTop: 10,
    marginRight: 15,
  },
  cvsPickUpGoodsHintText: {
    fontSize: 13,
    lineHeight: 16,
    color: peacock,
  },
});

export default styles;
